import ShipmentLink from "./ShipmentLink";

export default ShipmentLink;
